import { initializeApp } from "firebase/app";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectAuthEmulator, getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { connectFunctionsEmulator, getFunctions, httpsCallable } from "firebase/functions";
import { connectStorageEmulator, getStorage } from "firebase/storage";

const config = {
    apiKey: "AIzaSyAfuuqlYXLA6HNmzERQe4ZV59W6J6GQlNc",
    authDomain: "basketball-618.firebaseapp.com",
    databaseURL: "https://basketball-618-default-rtdb.firebaseio.com",
    projectId: "basketball-618",
    storageBucket: "basketball-618.appspot.com",
    messagingSenderId: "248712448015",
    appId: "1:248712448015:web:233c9d6bdd4527f7cc3b7a",
    measurementId: "G-1V5PCGF2T0"
};

const app = initializeApp(config);

/**
 *
 * AUTHENTICATION
 *
 */


export const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export const signInWithGoogle = () => {
	console.log('signing in')
	signInWithPopup(auth, provider)
	.then((result) => {

	}).catch(err => console.log(err))
}

/**
 *
 * EXPORT DATABASE REFS
 *
 */

export const db = getFirestore(app);

const functions = getFunctions(app);

/**
 *
 * LOCAL EMULATORS (npm run dev:emu)
 *
 */

if (import.meta.env.VITE_USE_EMULATORS === 'true') {
    connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
    connectFirestoreEmulator(db, '127.0.0.1', 8080);
    connectFunctionsEmulator(functions, '127.0.0.1', 5001);
    connectStorageEmulator(getStorage(app), '127.0.0.1', 9199);
    console.log('Using local Firebase emulators');
}

/**
 *
 * SIGN OUT
 *
 */

export const signOut = async () => {
	await auth.signOut();
	return true;
}

/**
 *
 * Use Cloud Function
 * Always resolves: {success, ...} on success, {error: message} on failure.
 *
 */

export const UseCloudFunction = async (command, data) => {
	console.log('cloud function', command)
	// Long timeout: simulating a full season takes about a minute.
	const processCommand = httpsCallable(functions, 'processCommand', { timeout: 540000 });
	try {
		const result = await processCommand({
			command: command,
			data: data
		})
		return result.data;
	} catch (err) {
		console.log(command, err);
		// details.problems: a list of input problems (e.g. a bad CSV upload).
		return { error: err.message, problems: err.details?.problems };
	}
}
